module.exports = __webpack_public_path__ + "img/cancel.6bcff3bb.svg";